import type { ComponentType } from 'react';

export interface ChangelogEntryFrontmatter {
  version: string;
  title: string;
  date: string;
  excerpt: string;
}

export interface ChangelogEntry {
  frontmatter: ChangelogEntryFrontmatter;
  Component: ComponentType;
}

const modules = import.meta.glob<{
  default: ComponentType;
  frontmatter: ChangelogEntryFrontmatter;
}>('/src/content/changelog/*.mdx', { eager: true });

export const changelogEntries: ChangelogEntry[] = Object.values(modules)
  .map((mod) => ({ frontmatter: mod.frontmatter, Component: mod.default }))
  .sort((a, b) => b.frontmatter.date.localeCompare(a.frontmatter.date));
